
/**
 * Details of the app.
 */
export const appDetails = {
    name: 'Talent-Ed Matrix',
}